import { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import "./enq.css";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
const Enqiry = () => {
  const [Msg, setMsg] = useState("");
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [Subject, setSubject] = useState("");
  const [Message, setMessage] = useState("");
  const [Variant, setVariant] = useState("");

  function Submitform(e) {
    e.preventDefault();

    if (FirstName === "") {
      setVariant("danger");
      setMsg("First name is required");
    }
    if (LastName === "") {
      setVariant("danger");
      setMsg("Last name is required");
    }
    if (Subject === "") {
      setVariant("danger");
      setMsg("Subject is required");
    }
    if (Message === "") {
      setVariant("danger");
      setMsg("Message is required");
    }
    if (
      FirstName !== "" &&
      LastName !== "" &&
      Subject !== "" &&
      Message !== ""
    ) {
      setVariant("success");
      setMsg("Submitted Successfully.");
      api();
    }
  }

  useEffect(() => {
    AOS.init({
      once: false,
      disable: "phone",
      duration: 1000,
      easing: "ease-out-cubic",
    });
  }, []);

  const api = async () => {
    const res = await axios.post(
      "https://www.realthinktechnology.com/api_contact.php",
      {
        fname: FirstName,
        lname: LastName,
        subject: Subject,
        msg: Message,
      }
    );

    console.log(res.data);
  };

  // ===contact=====

  return (
    <>
      <section data-aos="fade-up" className="service-section">
        <div class="container-fluid">
          <div class="container">
            <div class="row">
              <div data-aos="fade-down" class="col-lg-12 text-center">
                <h2 className="recent-title"> Contact Us</h2>
              </div>
            </div>

            <div class="row">
              <div data-aos="flip-left" class="col-lg-4">
                <div class="contact-sec">
                  <h3>
                    <i class="fa fa-envelope-o"></i> Email Us
                  </h3>
                  <p>contact@realthingtechnology.com</p>
                </div>
              </div>

              <div data-aos="flip-left" class="col-lg-4">
                <div class="contact-sec">
                  <h3>
                    <i class="fa fa-volume-control-phone"></i> Call Us
                  </h3>
                  <p> +91 9202109531</p>
                </div>
              </div>
              <div data-aos="flip-right" class="col-lg-4">
                <div class="contact-sec">
                  <h3>
                    <i class="fa fa-podcast"></i> Our Address
                  </h3>
                  <p>Sonagiri Sector-A , Bhopal,Madhya Pardesh</p>
                </div>
              </div>
              <div class="row">
                <div
                  data-aos="fade-up"
                  data-aos-duration="3000"
                  class="col-lg-6 col-12 "
                >
                  <div class="contact">
                    <form id="contactform" onSubmit={Submitform}>
                      <div class="row" style={{ marginTop: "15px" }}>
                        <div class="col-lg-6 col-6">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="First name"
                            onChange={(e) => {
                              setFirstName(e.target.value);
                            }}
                          />
                        </div>
                        <div className="col-lg-6  col-6">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Last name"
                            onChange={(e) => {
                              setLastName(e.target.value);
                            }}
                          />
                        </div>
                        <div className="col-12" style={{ marginTop: "25px" }}>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Subject"
                            onChange={(e) => {
                              setSubject(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div class="form-group" style={{ marginTop: "25px" }}>
                        <textarea
                          class="form-control"
                          placeholder="Message"
                          rows="4"
                          onChange={(e) => {
                            setMessage(e.target.value);
                          }}
                        ></textarea>
                      </div>
                      {Msg !== "" ? (
                        <Alert variant={Variant} style={{ marginTop: "15px" }}>
                          {Msg}
                        </Alert>
                      ) : (
                        ""
                      )}
                      <button
                        className="btn "
                        style={{ marginTop: "15px", color: "#fff" }}
                      >
                        Send Message
                      </button>
                    </form>
                  </div>
                </div>

                <div
                  data-aos="flip-left"
                  data-aos-duration="3000"
                  class="col-lg-6 col-12 "
                >
                  <iframe
                    className="map_location"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15608.171800381682!2d77.47311894322259!3d23.24097234931451!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1710074460710!5m2!1sen!2sin"
                    width="600"
                    height="350"
                    style={{ border: 0 }}
                    title="..."
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
       <div className="main-section1">
        <div className="container-fluid">
          <div class="container">
            <div class="row">
            <div className="col-lg-12 vlog">
                <h1 data-aos="fade-up" className="recent-title text-center">
                Frequently Asked questions
                </h1>
              </div>
              <div class="faq-container">
    <div class="faq-item">
      <div class="faq-question">
      Where is RealThink Technology located?
        <span class="arrow">▶</span>
      </div>
      <div class="faq-answer">
      We are based in Bhopal, Madhya Pradesh, India, and offer both offline and online services to clients and learners across India and beyond.


      </div>
    </div>
    <div class="faq-item">
      <div class="faq-question">
      Do you offer custom website or app development?
        <span class="arrow">▶</span>
      </div>
      <div class="faq-answer">
        Absolutely! We specialize in custom software, websites, and mobile apps based on your business goals, features, and branding needs.


      </div>
    </div>
    <div class="faq-item">
      <div class="faq-question">
      Can you help me promote my business online?
        <span class="arrow">▶</span>
      </div>
      <div class="faq-answer">
      Definitely! Our Digital Marketing team can handle everything from SEO, Google Ads, and social media marketing to email campaigns and branding strategies.


      </div>
    </div>
  </div>



            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Enqiry;
